<template>
  <form
      :class="{'nx-active': active}"
      :data-vv-scope="scope"
      :id="'scope-' + scope"
      class="nx-form">
    <h2 class="nx-form-legend mb-1 mt-2"
        v-html="$t('message.form.scopes.' + scope)"
        v-if="scope"
    ></h2>
    <div class="nx-form-fieldset">

      <nx-image
          class="mb-4 nx-primary--lighten-5"
          :src="image.originalImageUrl"
          :alt="draft.title"
          width="100%"
          height="500px"
      ></nx-image>

    </div>
  </form>
</template>

<script>
import FormScope from '@/modules/form/FormScope';
import api from '@/modules/clipping/api';
import NxImage from '@/components/media/Image';

export default {
  name: 'nx-form-content-image-preview',
  components: { NxImage },
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  extends: FormScope,
  data() {
    return {
      image: {},
      loaded: false,
    };
  },
  async mounted() {
    if (!this.loaded) {
      this.image = await api.getImage({ id: this.$getParentEditor().id });
      this.loaded = true;
    }
  },
};
</script>
